import ReactHtmlParser from "react-html-parser";

const lowSOP = `<div>
    <div style="margin-top: 20px;margin-bottom: 20px">
        These alerts will only generate when the volume in the alert bucket is above a threshold that we believe is normal for the time remaining in the CPT. These will only alert when the site must change how they are processing to ensure there are no negative impact to customers (Lates)
    </div>
    <strong>Steps:</strong></br>
    <ol>
        <li>Look for packages in the following locations for Pending Stow - Inducted packages; all packages are inducted and should have a yellow SAL label, awaiting stow:
            <ol type="a">
                <li>Buffer Racks
                    <ol type="i">
                        <li>Click into "Impacted Packages" within this exception.</li>
                        <li>View the assigned sort location for each respective TBA and look on the respective zone's buffer rack to stow the package. Prioritize TBAs dwelling 10-15 mins, then TBAs dwelling &gt;15 mins, followed by 0-10 mins.</li>
                    </ol>
                </li>
                <li>Jackpot (end of conveyance)</li>
            </ol>
        </li>
        <li>Evaluate increasing buffer or stow associate staffing based on where packages are building up. If packages are building up at Jackpot, increase buffer staffing. If packages are building up on buffer racks, increase staffing of stow associates.</li>
        <li>Continue to monitor the alert bucket to ensure the actions taken on site are driving down the volume in that bucket.</li>
        <li>The alert will be removed from HAWK once all packages are processed and no longer in that bucket.</li>
    </ol>
</div>`;

const mediumSOP = lowSOP;

const highSOP = `<div>
    <div style="margin-top: 20px;margin-bottom: 20px">
        Late alerts are generated after latest time to complete this process per the Ops Clock. These will only generate when the volume in the alert bucket is above a threshold that we believe is normal. This bucket is directly related to Late metrics. These alerts are generally used for bridging, since there are no actions that can be taken to address these and not have the packages be late.
    </div>
    <strong>Steps:</strong></br>
    <ol>
        <li>Look for packages in the following locations for Pending Stow - Inducted packages; all packages are inducted and should have a yellow SAL label, awaiting stow:
            <ol type="a">
                <li>Buffer Racks
                    <ol type="i">
                        <li>Click into "Impacted Packages" within this exception.</li>
                        <li>View the assigned sort location for each respective TBA and look on the respective zone's buffer rack to stow the package. Prioritize TBAs dwelling 10-15 mins, then TBAs dwelling &gt;15 mins, followed by 0-10 mins.</li>
                    </ol>
                </li>
                <li>Jackpot (end of conveyance)</li>
            </ol>
        </li>
        <li>Deep dive the alerts by using the "Copy TBAs to Clipboard; Open SCC" button in the HAWK tool. Since these packages are already late, they are typically not changing quickly in the alert, so a deep dive can help you understand where the package is and why it is late.</li>
        <li>Complete the actions that were identified from the deep dive to resolve any issues for the package or process that led to these packages being late. The alert will be removed from HAWK once all packages are processed and no longer in that bucket.</li>
        <li>Continue to monitor the alert bucket to ensure the actions taken on site are driving down the volume in that bucket.</li>
    </ol>
</div>`;

export default (sopParameters) => {
  const { criticality } = sopParameters || {};
  const sopContent = criticality === "high" ? highSOP : criticality === "medium" ? mediumSOP : lowSOP;
  const level = (criticality || "low").charAt(0).toUpperCase() + (criticality || "low").slice(1);
  return ReactHtmlParser(
    `<div>
  <h2>SSD NPLB Stow Inducted Site - ${level}</h2>
  <h3>Description</h3>
  <p>Packages that have been inducted but not stowed</p>
  <h3>SOP</h3>
  ${sopContent}
</div>`
  );
};



// WEBPACK FOOTER //
// ./src/components/taskExecution/TaskSOP/FallbackSOPWiki/SSD_NPLB_Stow_Inducted_Site.jsx